import React from "react";

import { AdminLocationAlertsListRow } from "../Row";

export interface IAdminLocationAlertsListHeaderProps {
  sortField?: string;
  sortDirection?: string;
  handleSort: (sortField: string) => void;
}

export const AdminLocationAlertsListHeader: React.FC<
  IAdminLocationAlertsListHeaderProps
> = ({ sortField, sortDirection, handleSort }) => {
  return (
    <AdminLocationAlertsListRow
      isHeader={true}
      sortField={sortField}
      sortDirection={sortDirection}
      handleSort={handleSort}
    />
  );
};
